import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { toastError, toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

const ShrinkageAndGSM = ({
	setShrinkageColumn,
	shrinkageColumn,
	productId,
	fetchMaterialListByProductId,
	item
}) => {
	const [shrinkageInput, setShrinkageInput] = useState({
		length: item.shrinkageLength >= 0 ? item.shrinkageLength : null,
		width: item.shrinkageWidth >= 0 ? item.shrinkageWidth : null,
		solidDryed: item.solidDyedGsm >= 0 ? item.solidDyedGsm : null,
		afterWash: item.afterWashGsm >= 0 ? item.afterWashGsm : null
	});

	const dispatch = useDispatch();

	const closeShrinkagePopup = (e) => {
		e.stopPropagation();
		setShrinkageColumn(false);
	};

	const onChangeShrinkage = (e) => {
		const { name, value } = e.target;
		if (parseInt(value) < 0) {
			toastError('Negative value not allowed!');
			return;
		}
		setShrinkageInput((prev) => ({
			...prev,
			[name]: value === '' ? null : value
		}));
	};

	const formatRequestBody = () => {
		const body = {
			...shrinkageColumn,
			shrinkageLength: shrinkageInput.length,
			shrinkageWidth: shrinkageInput.width,
			solidDyedGsm: shrinkageInput.solidDryed,
			afterWashGsm: shrinkageInput.afterWash,
			colorType: null
		};
		return body;
	};

	const onSubmitShrinkage = async () => {
		dispatch(openLoader());
		const requestBody = formatRequestBody();
		try {
			await ApiClient.PUT(`${BASE_URL}/product/${productId}/update-material`, requestBody, '', true);
			toastSuccess('Submitted successfully');
			setShrinkageColumn(null);
			fetchMaterialListByProductId();
		} catch (response) {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Request was unsuccessful.');
			}
		} finally {
			dispatch(closeLoader());
		}
	};

	return (
		<Modal show={!!shrinkageColumn} className="shrinkage-and-gsm-modal" backdrop="static" centered>
			<div>
				<Modal.Header>
					<div
						className="d-flex justify-content-between align-items-center px-1"
						style={{ width: '100%' }}
					>
						<h3 className="semibold-16 mb-0">Shrinkage & GSM</h3>
						<div onClick={closeShrinkagePopup} className="cursor-pointer">
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} />
						</div>
					</div>
				</Modal.Header>

				<Modal.Body>
					<div className="px-1">
						<h4 className="semibold-12 mb-2">Shrinkage %</h4>
						<div className="d-flex justify-content-between align-items-center gap-3">
							<div className="form-group">
								<label htmlFor="">Length(L) %</label>
								<input
									type="number"
									name="length"
									placeholder="%"
									value={shrinkageInput.length}
									onChange={onChangeShrinkage}
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Width(W) %</label>
								<input
									type="number"
									name="width"
									value={shrinkageInput.width}
									placeholder="%"
									onChange={onChangeShrinkage}
								/>
							</div>
						</div>
						<h4 className="semibold-12 mt-12 mb-2">GSM Count after style creation</h4>
						<div className="d-flex justify-content-between align-items-center gap-3">
							<div>
								<label htmlFor="">Solid dyed(S/D)</label>
								<input
									type="number"
									placeholder="GSM"
									name="solidDryed"
									value={shrinkageInput.solidDryed}
									onChange={onChangeShrinkage}
								/>
							</div>
							<div>
								<label htmlFor="">After wash(A/W)</label>
								<input
									type="number"
									value={shrinkageInput.afterWash}
									name="afterWash"
									placeholder="GSM"
									onChange={onChangeShrinkage}
									min={0}
								/>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div>
						<button className="button outline size32" onClick={closeShrinkagePopup}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={onSubmitShrinkage}>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default ShrinkageAndGSM;
